require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./saying-itsa-mea-mario.json") })
        }
      }, "path---saying-itsa-mea-mario");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---saying-itsa-mea-mario!./.cache/json/saying-itsa-mea-mario.json
// module id = 547
// module chunks = 231608221292675